//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productLinks', {
//        templateUrl: 'views/components/views/productLinks/productLinks.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'rememberService', 'productLinksService', function ($stateParams, stateService, utilityService, rememberService, productLinksService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
//            let productLinkTypeKeyno = $stateParams.productlinktype_keyno;

//            let variableNames = {
//                bg_productlinks: ''
//            };

//            vm.model = {
//                bgProductLinks: {
//                    selected: 'GOTO',
//                    buttons: [
//                        { id: 'GOTO', label: 'bg_productlinks_goto', color: 'primary', onClick: () => setProductLinksView('GOTO') },
//                        { id: 'EDIT', label: 'bg_productlinks_edit', color: 'primary', onClick: () => setProductLinksView('EDIT') }
//                    ]
//                },
//                setting: {},
//                itemsListLinks: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region BUTTON GROUP SINGLE FUNCTION

//            async function setProductLinksView(id) {
//                vm.model.bgProductLinks.selected = vm.model.setting.bg_productlinks = id;
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await productLinksService.getProductLinks({
//                    argtype: argType,
//                    argvalue: argValue,
//                    productlinktype_keyno: productLinkTypeKeyno
//                }))[0];
//            }
            
//            async function loadProductLinks() {
//                if (utilityService.validateParmsValue(vm.model.setting.bg_productlinks) !== true) return;
                
//                return vm.model.itemsListLinks = await productLinksService.listProductLinks(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'bg_productlinks':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgProductLinks = function (value) {
//                vm.model.bgProductLinks.selected = value;
//                vm.model.setting.bg_productlinks = vm.model.bgProductLinks.selected;

//                rememberFunc('bg_productlinks');
//                loadProductLinks();
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                setProductLinksView(vm.model.setting.bg_productlinks);
//                loadProductLinks();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
